<template>
  <div>
    <el-table
      ref="table"
      id="dataTable"
      class="ren-table"
      :data="tableData"
      style="width: 100%"
      height="100%"
      :size="size"
      :border="true"
      :stripe="true"
      :highlight-current-row="true"
      header-cell-class-name="table-header-cell"
      cell-class-name="table-cell"
      fit
      :span-method="handleSpanMethod"
    >
      <el-table-column
        prop="time"
        label="时间"
        min-width="160"
        header-align="center"
        align="center"
        fixed="left"
      ></el-table-column>
      <el-table-column
        v-for="column in headercolumns"
        :key="column.assetsFixed"
        :label="column.label"
        header-align="center"
        align="left"
      >
        <el-table-column
          :prop="column.propObject[0].prop"
          label="总用电量"
          min-width="120"
          header-align="center"
          align="right"
          :formatter="formatValue"
        ></el-table-column>
        <el-table-column
          :prop="column.propObject[1].prop"
          v-if="dateType != 'hour'"
          :label="dateType == 'day' ? '平均每日用电量' : '平均每月用电量'"
          min-width="120"
          header-align="center"
          align="right"
          :formatter="formatValue"
        ></el-table-column>
        <el-table-column
          :prop="column.propObject[2].prop"
          v-if="dateType == 'hour'"
          label="用电量"
          min-width="120"
          header-align="center"
          align="right"
          :formatter="formatValue"
        ></el-table-column>
      </el-table-column>
      <el-table-column
        v-for="column in otherColumns"
        :key="column.assetsFixed"
        :label="column.label"
        header-align="center"
        align="left"
      >
        <el-table-column
          v-for="item in column.propObject"
          :prop="item.prop + column.measureId"
          :key="item.prop"
          :label="item.name"
          min-width="120"
          header-align="center"
          align="right"
          :formatter="formatValue"
        ></el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "dataTable",
  props: {
    dateType: String,
    // dataType: Array,
    tableData: Array,
    selectItem: Array,
    // columns: Array,
    size: {
      // 尺寸样式
      type: String,
      default: "mini",
    },
  },
  methods: {
    formatValue(row, column, cellValue, index) {
      if (cellValue == undefined || cellValue == null || cellValue == "--") {
        return "--";
      } else {
        //console.log(cellValue);

        return parseFloat(cellValue).toFixed(2);
      }
    },
    changeDataType(type) {
      this.dataType = type;
    },
    changeColumns(headercolumns, otherColumns) {
      this.columns = [];
      this.headercolumns = headercolumns;
      this.otherColumns = otherColumns;
      this.columns = this.columns.concat(this.headercolumns, this.otherColumns);
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
    handleSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (this.headercolumns.length === 1) {
        if (columnIndex === 1) {
          if (rowIndex === 0) {
            return {
              rowspan: this.tableData.length,
              colspan: 1,
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
        } else if (columnIndex === 2 && this.dateType !== "hour") {
          if (rowIndex === 0) {
            return {
              rowspan: this.tableData.length,
              colspan: 1,
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
        }
      } else if (this.otherColumns.length === 1) {
        //console.log("(this.otherColumns === 1)");
        if (columnIndex === 1) {
          if (rowIndex === 0) {
            return {
              rowspan: this.tableData.length,
              colspan: 1,
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
        }
      } else {
        if (columnIndex === 1) {
          if (rowIndex === 0) {
            return {
              rowspan: this.tableData.length,
              colspan: 1,
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
        } else if (columnIndex === 2 && this.dateType !== "HOUR") {
          if (rowIndex === 0) {
            return {
              rowspan: this.tableData.length,
              colspan: 1,
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
        } else if (columnIndex === 4 && this.dateType !== "HOUR") {
          if (rowIndex === 0) {
            return {
              rowspan: this.tableData.length,
              colspan: 1,
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
        } else if (columnIndex === 6 && this.dateType !== "HOUR") {
          if (rowIndex === 0) {
            return {
              rowspan: this.tableData.length,
              colspan: 1,
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
        } else if (columnIndex === 8 && this.dateType !== "HOUR") {
          if (rowIndex === 0) {
            return {
              rowspan: this.tableData.length,
              colspan: 1,
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
        } else if ((columnIndex - 1) % 2 === 0) {
          if (rowIndex === 0) {
            return {
              rowspan: this.tableData.length,
              colspan: 1,
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
        }
      }
    },
  },
  data() {
    return {
      columns: [],
      dataType: [],
      headercolumns: [],
      otherColumns: [],
    };
  },
};
</script>

<style scoped>
</style>
